import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-360e127d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "gutter-y-s2" }
const _hoisted_2 = { class: "swap-info-item" }
const _hoisted_3 = { class: "swap-info-item" }
const _hoisted_4 = { class: "flex align-items-center" }
const _hoisted_5 = {
  key: 1,
  class: "caption"
}
const _hoisted_6 = { class: "flex-order-0" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-order-4" }, [
  /*#__PURE__*/_createElementVNode("span", null, "1")
], -1))
const _hoisted_8 = {
  key: 0,
  class: "swap-info-item"
}
const _hoisted_9 = {
  key: 1,
  class: "caption"
}
const _hoisted_10 = {
  key: 1,
  class: "swap-info-item"
}
const _hoisted_11 = {
  key: 1,
  class: "caption"
}
const _hoisted_12 = {
  key: 2,
  class: "swap-info-item"
}
const _hoisted_13 = {
  key: 3,
  class: "swap-info-item"
}
const _hoisted_14 = {
  key: 4,
  class: "swap-info-item"
}
const _hoisted_15 = {
  key: 1,
  class: "caption"
}
const _hoisted_16 = { key: 2 }
const _hoisted_17 = {
  key: 5,
  class: "swap-info-item"
}
const _hoisted_18 = {
  key: 1,
  class: "caption"
}
const _hoisted_19 = { key: 2 }
const _hoisted_20 = {
  key: 0,
  class: "swap-info-item"
}
const _hoisted_21 = { class: "text-default" }
const _hoisted_22 = { class: "text-default" }
const _hoisted_23 = { class: "mt-s2" }
const _hoisted_24 = {
  key: 1,
  class: "caption"
}
const _hoisted_25 = { key: 2 }
const _hoisted_26 = {
  key: 1,
  class: "swap-info-item"
}
const _hoisted_27 = {
  key: 1,
  class: "caption"
}
const _hoisted_28 = { key: 2 }
const _hoisted_29 = {
  key: 2,
  class: "swap-info-item"
}
const _hoisted_30 = {
  key: 1,
  class: "caption"
}
const _hoisted_31 = { key: 2 }

import { computed, ref } from 'vue';
import { getNetworkParams } from '@/helpers/networkParams.helper';
import ControlIcon from '@/components/icon/ControlIcon.vue';
import { format } from '@/utils/format';
import Skeleton from 'primevue/skeleton';
import TokenIcon from '@/components/token/TokenIcon.vue';
import { useI18n } from 'vue-i18n';
import Caption from '@/components/Caption.vue';
import { useTokens } from '@/store/modules/tokens/useTokens';
import { useSwap } from '@/store/modules/swap/useSwap';
import { useSwapInfo } from '@/store/modules/swap/useSwapInfo';
import {
  BRIDGE_FEE_CARDANO_IN_ADA,
  BRIDGE_FEE_MILKOMEDA_IN_ADA,
} from '@/helpers/milkomeda-wrapped-smartcontract/milkomeda-wsc-calculation';
import { ENABLE_FAKE_CARDANO_NETWORK } from '@/helpers/fakeCardanoNetwork';
import { CARDANO_VIA_MILKOMEDA_NETWORK_NAME } from '@/constants/NETWORK_NAMES';
import { DEFAULT_CARDANO_CHAIN_ID } from '@/constants/DEFAULT_CARDANO_ID';
import { PRICE_IMPACT_MAX } from '@/store/modules/swap/constants/SWAP_PRICE_IMPACT_MAX';


export default /*#__PURE__*/_defineComponent({
  __name: 'SwapInfo',
  setup(__props) {

const { t } = useI18n();
const { isPresentTokenIntoNetwork } = useTokens();
const { swapForm } = useSwap();
const { swapInfo } = useSwapInfo();

const priceInverse = ref(false);
const setPriceInverse = () => {
  priceInverse.value = !priceInverse.value;
};
const destinationChainName = computed(() => {
  const outputToken = swapForm.output.token;
  const destinationChainId = outputToken?.chainId ?? -1;

  if (!ENABLE_FAKE_CARDANO_NETWORK) {
    return getNetworkParams(destinationChainId).chainName || '--';
  }

  if (isPresentTokenIntoNetwork(outputToken?.symbol ?? '', +DEFAULT_CARDANO_CHAIN_ID!)) {
    return CARDANO_VIA_MILKOMEDA_NETWORK_NAME;
  }

  return getNetworkParams(destinationChainId).chainName || '--';
});
const isLoading = computed<boolean>(() => swapForm.bestTradeRequestInProgress);
const noSwapInfo = computed<boolean>(() => Object.keys(swapForm.bestTrade).length === 0);

// PRICE IMPACT
const isShowPriceImpact = computed<boolean>(() => !swapForm.isSwapSameTokensFromMilkomedaToCardano);
const isPriceImpactTooBig = computed(() => Number(swapInfo.priceImpact) > PRICE_IMPACT_MAX);

// MINIMUM RECEIVED
const isShowMinimumReceivedLoading = computed<boolean>(
  () => !swapForm.isSwapSameTokensFromMilkomedaToCardano && (isLoading.value || noSwapInfo.value),
);
const isShowMinimumReceived = computed<boolean>(
  () => !swapForm.isSwapSameTokensFromMilkomedaToCardano && !!swapForm.output.estimated,
);

// LIQUIDITY PROVIDER FEE
const isShowLiquidityProviderFee = computed(() => !swapForm.isSwapSameTokensFromMilkomedaToCardano);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(Caption, {
          caption: _unref(t)('swap.swapInfo.destinationChain.caption'),
          tooltip: _unref(t)('swap.swapInfo.destinationChain.tooltip')
        }, null, 8, ["caption", "tooltip"]),
        _createElementVNode("div", null, _toDisplayString(_unref(destinationChainName)), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(Caption, {
          caption: _unref(t)('swap.swapInfo.price.caption'),
          tooltip: _unref(t)('swap.swapInfo.price.tooltip')
        }, null, 8, ["caption", "tooltip"]),
        _createElementVNode("div", _hoisted_4, [
          (_unref(isLoading))
            ? (_openBlock(), _createBlock(_unref(Skeleton), {
                key: 0,
                class: "tx-info-skeleton p-skeleton_light"
              }))
            : (_unref(noSwapInfo))
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, "--"))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(priceInverse.value ? _unref(format)(_unref(swapInfo).price ?? '') : _unref(format)(_unref(swapInfo).priceInverse ?? '')), 1),
                  _createElementVNode("div", {
                    class: _normalizeClass(["flex ml-s1 align-items-center gutter-x-s1", !priceInverse.value ? 'flex-order-1' : 'flex-order-6'])
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_unref(swapForm).input.token?.symbol), 1),
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('on')), 1),
                    _createVNode(TokenIcon, {
                      "icon-src": _unref(getNetworkParams)(_unref(swapForm).input.token?.chainId).iconUrls?.[0],
                      size: "16"
                    }, null, 8, ["icon-src"])
                  ], 2),
                  _createVNode(ControlIcon, {
                    disabled: _unref(isLoading),
                    name: "exchange",
                    size: "16",
                    class: "mx-s1 flex-order-3",
                    onClick: setPriceInverse
                  }, null, 8, ["disabled"]),
                  _hoisted_7,
                  _createElementVNode("div", {
                    class: _normalizeClass(["flex ml-s1 align-items-center gutter-x-s1", !priceInverse.value ? 'flex-order-6' : 'flex-order-1'])
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_unref(swapForm).output.token?.symbol), 1),
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('on')), 1),
                    _createVNode(TokenIcon, {
                      "icon-src": _unref(getNetworkParams)(_unref(swapForm).output.token?.chainId).iconUrls?.[0],
                      size: "16"
                    }, null, 8, ["icon-src"])
                  ], 2)
                ], 64))
        ])
      ]),
      (_unref(isShowPriceImpact))
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(Caption, {
              caption: _unref(t)('swap.swapInfo.priceImpact.caption'),
              tooltip: _unref(t)('swap.swapInfo.priceImpact.tooltip')
            }, null, 8, ["caption", "tooltip"]),
            _createElementVNode("div", {
              class: _normalizeClass(_unref(isPriceImpactTooBig) ? 'text-danger' : '')
            }, [
              (_unref(isLoading))
                ? (_openBlock(), _createBlock(_unref(Skeleton), {
                    key: 0,
                    class: "tx-info-skeleton p-skeleton_light"
                  }))
                : (_unref(noSwapInfo))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, "--"))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createTextVNode(_toDisplayString(_unref(swapInfo).priceImpact?.toFixed(2)) + " %", 1)
                    ], 64))
            ], 2)
          ]))
        : _createCommentVNode("", true),
      (_unref(isShowMinimumReceivedLoading))
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(Caption, {
              caption: _unref(t)('swap.swapInfo.minimumReceived.caption'),
              tooltip: _unref(t)('swap.swapInfo.minimumReceived.tooltip')
            }, null, 8, ["caption", "tooltip"]),
            _createElementVNode("div", null, [
              (_unref(isLoading))
                ? (_openBlock(), _createBlock(_unref(Skeleton), {
                    key: 0,
                    class: "tx-info-skeleton p-skeleton_light"
                  }))
                : (_unref(noSwapInfo))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, "--"))
                  : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (!_unref(isShowMinimumReceivedLoading) && _unref(isShowMinimumReceived))
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(Caption, {
              caption: _unref(t)('swap.swapInfo.minimumReceived.caption'),
              tooltip: _unref(t)('swap.swapInfo.minimumReceived.tooltip')
            }, null, 8, ["caption", "tooltip"]),
            _createElementVNode("div", null, _toDisplayString(_unref(format)(_unref(swapInfo).minimumReceived ?? 0)) + " " + _toDisplayString(_unref(swapForm).output.token?.symbol), 1)
          ]))
        : (!_unref(isShowMinimumReceivedLoading) && _unref(swapInfo)?.maximumSold)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createVNode(Caption, {
                caption: _unref(t)('swap.swapInfo.maximumSold.caption'),
                tooltip: _unref(t)('swap.swapInfo.maximumSold.tooltip')
              }, null, 8, ["caption", "tooltip"]),
              _createElementVNode("div", null, _toDisplayString(_unref(format)(_unref(swapInfo).maximumSold ?? 0)) + " " + _toDisplayString(_unref(swapForm).input.token?.symbol), 1)
            ]))
          : _createCommentVNode("", true),
      (_unref(isShowLiquidityProviderFee))
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createVNode(Caption, {
              caption: _unref(t)('swap.swapInfo.liquidityProviderFee.caption'),
              tooltip: _unref(t)('swap.swapInfo.liquidityProviderFee.tooltip')
            }, null, 8, ["caption", "tooltip"]),
            _createElementVNode("div", null, [
              (_unref(isLoading))
                ? (_openBlock(), _createBlock(_unref(Skeleton), {
                    key: 0,
                    class: "tx-info-skeleton p-skeleton_light"
                  }))
                : (_unref(noSwapInfo))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, "--"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_unref(format)(_unref(swapInfo).lpFee ?? '')) + " " + _toDisplayString(_unref(swapForm).input.token?.symbol), 1))
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(swapInfo).crossChainFee)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createVNode(Caption, {
              caption: _unref(t)('swap.swapInfo.crossChainFee.caption'),
              tooltip: _unref(t)('swap.swapInfo.crossChainFee.tooltip')
            }, null, 8, ["caption", "tooltip"]),
            _createElementVNode("div", null, [
              (_unref(isLoading))
                ? (_openBlock(), _createBlock(_unref(Skeleton), {
                    key: 0,
                    class: "tx-info-skeleton p-skeleton_light"
                  }))
                : (_unref(noSwapInfo))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, "--"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_unref(format)(_unref(swapInfo).crossChainFee ?? '')) + " " + _toDisplayString(_unref(swapForm).input.token?.symbol), 1))
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(ENABLE_FAKE_CARDANO_NETWORK))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
            (_unref(swapInfo).bridgeFee)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createVNode(Caption, {
                    caption: _unref(t)('swap.swapInfo.bridgeFees.caption'),
                    withFormattedText: ""
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createTextVNode(_toDisplayString(_unref(t)('swap.swapInfo.bridgeFees.tooltip.bridgeFee', {
                  chain: 'Milkomeda',
                  action: _unref(t)('swap.swapInfo.wrapping').toLowerCase(),
                })) + ": ", 1),
                        _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(BRIDGE_FEE_CARDANO_IN_ADA)) + " ADA", 1)
                      ]),
                      _createElementVNode("div", null, [
                        _createTextVNode(_toDisplayString(_unref(t)('swap.swapInfo.bridgeFees.tooltip.bridgeFee', {
                  chain: 'Milkomeda',
                  action: _unref(t)('swap.swapInfo.unwrapping').toLowerCase(),
                })) + ": ", 1),
                        _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(BRIDGE_FEE_MILKOMEDA_IN_ADA)) + " ADA", 1)
                      ]),
                      _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(t)('swap.swapInfo.bridgeFees.tooltip.text')), 1)
                    ]),
                    _: 1
                  }, 8, ["caption"]),
                  _createElementVNode("div", null, [
                    (_unref(isLoading))
                      ? (_openBlock(), _createBlock(_unref(Skeleton), {
                          key: 0,
                          class: "tx-info-skeleton p-skeleton_light"
                        }))
                      : (_unref(noSwapInfo))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, "--"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_unref(format)(_unref(swapInfo).bridgeFee)) + " ADA", 1))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_unref(swapInfo).bridgeLockUp)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createVNode(Caption, {
                    caption: _unref(t)('swap.swapInfo.bridgeLockUp.caption'),
                    tooltip: _unref(t)('swap.swapInfo.bridgeLockUp.tooltip')
                  }, null, 8, ["caption", "tooltip"]),
                  _createElementVNode("div", null, [
                    (_unref(isLoading))
                      ? (_openBlock(), _createBlock(_unref(Skeleton), {
                          key: 0,
                          class: "tx-info-skeleton p-skeleton_light"
                        }))
                      : (_unref(noSwapInfo))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, "--"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_unref(format)(_unref(swapInfo).bridgeLockUp)) + " ADA", 1))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_unref(swapInfo).evmLockUp)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _createVNode(Caption, {
                    caption: _unref(t)('swap.swapInfo.evmLockUp.caption'),
                    tooltip: _unref(t)('swap.swapInfo.evmLockUp.tooltip')
                  }, null, 8, ["caption", "tooltip"]),
                  _createElementVNode("div", null, [
                    (_unref(isLoading))
                      ? (_openBlock(), _createBlock(_unref(Skeleton), {
                          key: 0,
                          class: "tx-info-skeleton p-skeleton_light"
                        }))
                      : (_unref(noSwapInfo))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, "--"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_unref(format)(_unref(swapInfo).evmLockUp)) + " ADA", 1))
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})